import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import {
  MainContainer,
  LeftUserProfile,
  RightUserProfile,
} from './UserDetails.styles';
import UserCoursesSideMenu from './SideMenu/UserCoursesSideMenu.component';
import UserDetailsSideMenu from './SideMenu/UserDetailsSideMenu.component';
import UserDetailData from './UserDetail/UserDetail.component';
import UserEdit from './UserEdit/UserEdit.component';
import UserCourseDetails from './UserCourses/UserCourses.component';
import UserPurchases from './UserPurchases/UserPurchases.component';
import Auth from '../Helpers/auth';

const UserDetailsInner = ({ user, userId, courses }) => {
  const [selectedSection, setSelectedSection] = useState('details');
  const [selectedCourseId, setSelectedCourseId] = useState(
    user?.courses?.[0]?._id || null
  );
  const { data: userData } = Auth.getProfile();

  // If user or courses change, reset selected course
  useEffect(() => {
    if (selectedSection === 'courses' && user?.courses?.length > 0) {
      setSelectedCourseId(user.courses[0]._id);
    }
  }, [user, selectedSection]);

  return (
    <MainContainer>
      <LeftUserProfile>
        {selectedSection === 'courses' ? (
          <UserCoursesSideMenu
            user={user}
            setSelectedSection={setSelectedSection}
            selectedCourseId={selectedCourseId}
            setSelectedCourseId={setSelectedCourseId}
          />
        ) : (
          <UserDetailsSideMenu
            user={user}
            selectedSection={selectedSection}
            setSelectedSection={setSelectedSection}
          />
        )}
      </LeftUserProfile>
      <RightUserProfile>
        {selectedSection === 'details' && (
          <UserDetailData user={user} userData={userData} />
        )}
        {selectedSection === 'edit' && (
          <UserEdit user={user} userData={userData} courses={courses} />
        )}
        {selectedSection === 'purchased' && (
          <UserPurchases userId={userId} user={user} />
        )}
        {selectedSection === 'courses' && selectedCourseId && (
          <UserCourseDetails
            user={user}
            userId={userId}
            courseId={selectedCourseId}
            userData={userData}
            course={
              user.courses.find((c) => c._id === selectedCourseId) || null
            }
          />
        )}
      </RightUserProfile>
    </MainContainer>
  );
};

UserDetailsInner.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.string,
  courses: PropTypes.array,
};

export default UserDetailsInner;
